import React from 'react';

import {
  UserAuthHandlerMachineSendType,
  UserAuthHandlerMachineStateType,
  withUserAuthHandlerMachine
} from '@nw/client-auth-manager';

import DmLoginPageInterface from '../CustomizableLoginPage/DmLoginPageInterface';

interface LoginPageProps {
  onSuccessfulLogin: (
    userAuthHandlerMachineState: UserAuthHandlerMachineStateType
  ) => void;
  userAuthHandlerMachineState: UserAuthHandlerMachineStateType;
  userAuthHandlerMachineSend: UserAuthHandlerMachineSendType;
}

const LoginPage: React.FC<LoginPageProps> = ({
  onSuccessfulLogin,
  userAuthHandlerMachineState,
  userAuthHandlerMachineSend
}) => {
  const renderLoginPage = (): JSX.Element => {
    const defaultProps: LoginPageProps = {
      onSuccessfulLogin,
      userAuthHandlerMachineState,
      userAuthHandlerMachineSend
    };

    return <DmLoginPageInterface {...defaultProps} />;
  };

  return renderLoginPage();
};

export default withUserAuthHandlerMachine(LoginPage as any);
